export default __webpack_public_path__ + "static/media/quiz-dive.1d412864.png";